import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import FloatingCTA from '@/components/FloatingCTA/FloatingCTA';
import StrapiImage from '@/components/StrapiImage/StrapiImage';
import OnlyDesktop from '@/components/ui/OnlyDesktop/OnlyDesktop';
import PageMargins from '@/components/ui/PageMargins/PageMargins';
import PageTopMarginWrapper from '@/components/ui/PageTopMarginWrapper/PageTopMarginWrapper';
import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

import {
  DirectRequestForm,
  FormWrapper,
  Heading,
  ImageWrapper,
} from './DirectRequestHero.style';

const DirectRequestHero = ({ headline, pictures }) => {
  const mobileMediaQuery = useMobileMediaQuery();
  const [floatingCTA, setFloatingCTA] = useState(false);
  const directRequestFormRef = useRef();

  const handleCTAClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScroll = () => {
      const ref = directRequestFormRef.current;
      if (ref) {
        setFloatingCTA(
          ref.getBoundingClientRect().bottom < (mobileMediaQuery ? 0 : 67)
        );
      }
    };
    window.addEventListener('scroll', handleScroll, true);

    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [mobileMediaQuery]);

  return (
    <PageTopMarginWrapper>
      <PageMargins>
        <Stack alignItems="center" mb={4}>
          <Heading>{headline}</Heading>
          <Stack
            direction="row"
            justifyContent={
              mobileMediaQuery || !pictures ? 'center' : 'space-between'
            }
            sx={{ width: '100%' }}>
            {pictures && (
              <OnlyDesktop>
                <ImageWrapper>
                  <StrapiImage data={pictures} />
                </ImageWrapper>
              </OnlyDesktop>
            )}
            <FormWrapper>
              <DirectRequestForm ref={directRequestFormRef} />
              {floatingCTA && <FloatingCTA onClick={handleCTAClick} />}
            </FormWrapper>
          </Stack>
        </Stack>
      </PageMargins>
    </PageTopMarginWrapper>
  );
};

DirectRequestHero.propTypes = {
  headline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  pictures: PropTypes.object,
};

export default DirectRequestHero;
